import { AppProviders } from 'app/providers/AppProviders'
import { AppRoutes } from 'app/routes/AppRoutes'

const EnvironmentTopBar = () => {
  if (typeof window === 'undefined') return null

  const hostname = window.location.hostname

  if (hostname === 'demo.selektia.io') {
    return (
      <div className="w-full bg-amber-500 text-white text-xs sm:text-sm text-center py-1 z-50">
        Demo Selektia
      </div>
    )
  }

  if (hostname === 'dev.selektia.io') {
    return (
      <div className="w-full bg-blue-600 text-white text-xs sm:text-sm text-center py-1 z-50">
        Dev Selektia
      </div>
    )
  }

  return null
}

function App() {
  return (
    <AppProviders>
      <EnvironmentTopBar />
      <AppRoutes />
    </AppProviders>
  )
}

export default App